import { DateTime } from 'luxon';

export function dateInPast(date) {
  return DateTime.fromISO(date).diffNow().as('seconds') < 0;
}

export function commafyNumber(number) {
  return (number || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}